<template>
  <div id="app">
    <v-app id="inspire">

      <v-content>
        <v-layout v-if="listegorunum" row wrap>
          <v-flex xs12 sm12 md12>
            <v-tabs v-model="active" grow color="white" slider-color="info">
              <v-tab>
                Genel
              </v-tab>
              <v-tab-item>
                <v-card color="grey lighten-5" flat>
                  <v-flex pa-1 xs12 sm3 md3>
                    <v-layout justify-space-between column>
                      <v-text-field hide-details="" disabled="" v-model="ManageInfo.UserInfo.Email" label="E-Posta">
                      </v-text-field>
                      <v-text-field hide-details="" v-model="ManageInfo.UserInfo.AdSoyad" label="Ad Soyad"></v-text-field>
                      <v-text-field hide-details="" v-model="ManageInfo.UserInfo.GSM" label="Cep Telefonu"></v-text-field>
                    </v-layout>

                  </v-flex>
                </v-card>
              </v-tab-item>
              <v-tab ripple>
                Yetkİler
              </v-tab>
              <v-tab-item>
                <v-layout row wrap>
                  <v-flex xs6 sm6 md6>

                    <v-layout justify-start>
                      <v-icon large>people</v-icon>
                      <span class=" grey--text headline"> &nbsp; Kullanıcı Yetkileri</span>
                    </v-layout>
                  </v-flex>
                  <v-flex xs6 sm6 md6>
                    <v-layout justify-end>
                      <v-btn @click="satirekle()" flat color="info">
                        <v-icon>add_box</v-icon> Yeni Ekle
                      </v-btn>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-layout justify-end>
                      <v-divider></v-divider>
                    </v-layout>
                  </v-flex>



                  <v-layout row wrap>
                    <v-flex xs12 sm12 md12>
                      <v-list two-line>

                        <template>
                          <v-layout row wrap>


                            <v-flex xs12 sm2 md2>
                              <v-layout column="" align-start>
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content>
                                      <v-layout align-center>
                                        <v-flex>
                                          <v-list-tile-sub-title>
                                            <v-layout column align-center>
                                              Kullanıcı Tip</v-layout>
                                          </v-list-tile-sub-title>
                                        </v-flex>
                                      </v-layout>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm3 md3>
                              <v-layout column="" align-start>
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content>
                                      <v-layout align-center>
                                        <v-flex>
                                          <v-list-tile-sub-title>
                                            <v-layout column align-center>
                                              Kod</v-layout>
                                          </v-list-tile-sub-title>
                                        </v-flex>
                                      </v-layout>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm4 md4>
                              <v-layout column="" align-start>
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content>
                                      <v-layout align-center>
                                        <v-flex>
                                          <v-list-tile-sub-title>
                                            <v-layout column align-center>
                                              Ünvan</v-layout>
                                          </v-list-tile-sub-title>
                                        </v-flex>
                                      </v-layout>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex>



                            <!-- <v-flex xs12 sm4 md2>
                              <v-layout column="" align-start>
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content>
                                      <v-layout align-center>
                                        <v-flex>
                                          <v-list-tile-sub-title>
                                            <v-layout column align-center>
                                              Referans
                                            </v-layout>
                                          </v-list-tile-sub-title>
                                        </v-flex>
                                      </v-layout>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex> -->

                            <!--
                            <v-flex xs12 sm4 md2>
                              <v-layout column="" align-start>
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content>
                                      <v-layout align-center>
                                        <v-flex>
                                          <v-list-tile-sub-title>
                                            <v-layout column align-center>
                                              Masraf
                                            </v-layout>
                                          </v-list-tile-sub-title>
                                        </v-flex>
                                      </v-layout>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex> -->
                            <!-- <v-flex xs12 sm4 md2>
                              <v-layout column="" align-start>
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content>
                                      <v-layout align-center>
                                        <v-flex>
                                          <v-list-tile-sub-title>
                                            <v-layout column align-center>
                                              Bölüm</v-layout>
                                          </v-list-tile-sub-title>
                                        </v-flex>
                                      </v-layout>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex> -->

                            <v-flex xs12 sm2 md2>
                              <v-layout justify-center="" align-center>
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content>
                                      <v-layout justify-center="" align-center>
                                        <v-flex>
                                          <v-list-tile-sub-title>
                                            <v-layout column justify-center="" align-center>
                                              Durum
                                            </v-layout>
                                          </v-list-tile-sub-title>
                                        </v-flex>
                                      </v-layout>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex>


                            <v-flex xs12 sm1 md1>
                              <v-layout justify-center="" align-center>
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content>
                                      <v-layout justify-center="" align-center>
                                        <v-flex>
                                          <v-list-tile-sub-title>
                                            <v-layout column justify-center="" align-center>
                                              İşlem
                                            </v-layout>
                                          </v-list-tile-sub-title>
                                        </v-flex>
                                      </v-layout>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex>




                          </v-layout>
                          <v-divider></v-divider>
                        </template>

                        <template v-for="item in yetkilist">
                          <v-layout row wrap v-bind:key="item.MusteriKod">

                            <v-flex xs12 sm2 md2>
                              <v-layout column="" align-start>
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content>
                                      <v-layout align-center>
                                        <v-flex>
                                          <v-list-tile-sub-title>
                                            <v-layout column align-center>
                                              <v-chip v-if="item.UserTip=='1'">
                                                <v-avatar class="white--text red">A</v-avatar>
                                                Admin
                                              </v-chip>
                                              <v-chip v-if="item.UserTip=='0'">
                                                <v-avatar class="white--text info">S</v-avatar>
                                                Standart
                                              </v-chip>
                                            </v-layout>
                                          </v-list-tile-sub-title>
                                        </v-flex>
                                      </v-layout>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm3 md3>
                              <v-layout column="" align-start>
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content>
                                      <v-layout align-center>
                                        <v-flex>
                                          <v-list-tile-sub-title>
                                            <v-layout column align-center>
                                              {{item.MusteriKod}}</v-layout>
                                          </v-list-tile-sub-title>
                                        </v-flex>
                                      </v-layout>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm2 md4>
                              <v-layout column="" align-start>
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content>
                                      <v-layout align-center>
                                        <v-flex>
                                          <v-list-tile-sub-title>
                                            <v-layout column align-center>
                                              {{item.MusteriUnvan}}</v-layout>
                                          </v-list-tile-sub-title>
                                        </v-flex>
                                      </v-layout>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex>

                            <!-- <v-flex xs12 sm2 md2>
                              <v-layout column="" align-start>
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content>
                                      <v-layout align-center>
                                        <v-flex>
                                          <v-list-tile-sub-title>
                                            <v-layout column align-center>
                                              {{item.Referans}}
                                            </v-layout>
                                          </v-list-tile-sub-title>
                                        </v-flex>
                                      </v-layout>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex> -->


                            <!-- <v-flex xs12 sm2 md2>
                              <v-layout column="" align-start>
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content>
                                      <v-layout align-center>
                                        <v-flex>
                                          <v-list-tile-sub-title>
                                            <v-layout column align-center>
                                              {{item.Masraf}}
                                            </v-layout>
                                          </v-list-tile-sub-title>
                                        </v-flex>
                                      </v-layout>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm2 md2>
                              <v-layout column="" align-start>
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content>
                                      <v-layout align-center>
                                        <v-flex>
                                          <v-list-tile-sub-title>
                                            <v-layout column align-center>
                                              {{item.Bolum}}</v-layout>
                                          </v-list-tile-sub-title>
                                        </v-flex>
                                      </v-layout>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex> -->

                            <v-flex xs12 sm1 md2>
                              <v-layout justify-end="" align-center row fill-height="">
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content>
                                      <v-layout row align-center fill-height="" justify-end="">

                                        <v-chip v-if="item.Aktif==true">
                                          <v-avatar class="white--text green">A</v-avatar>
                                          Aktif
                                        </v-chip>
                                        <v-chip v-if="item.Aktif==false">
                                          <v-avatar class="white--text red">P</v-avatar>
                                          Pasif
                                        </v-chip>

                                      </v-layout>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex>


                            <v-flex xs12 sm1 md1>
                              <v-layout justify-end="" align-center row fill-height="">
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content>
                                      <v-layout row align-center fill-height="" justify-end="">
                                        <v-flex ma-2 xs12 sm4 md3>
                                          <v-btn :disabled="!item.Yetki==1" small icon class="mx-0" @click="detayagit(item)">
                                            <v-icon large color="green">edit</v-icon>
                                          </v-btn>
                                        </v-flex>
                                        <v-flex ma-2 xs12 sm4 md3>
                                          <v-btn :disabled="!item.Yetki==1" small icon class="mx-0" @click="listesil(item)">
                                            <v-icon large color="red">delete</v-icon>
                                          </v-btn>
                                        </v-flex>

                                      </v-layout>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-divider :key="item.id"></v-divider>
                        </template>

                      </v-list>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-tab-item>
            </v-tabs>
          </v-flex>

        </v-layout>


      </v-content>


      <navi v-model="drawer"></navi>

      <v-dialog v-model="dialoglisteduzenle" persistent max-width="400px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{dialogbaslik}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-flex pa-1 xs12 sm12 md12>
            <v-layout wrap>
              <v-card class="white--text">
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-layout row wrap>
                      <v-flex pa-1 xs12 sm12 md12>
                        <v-layout justify-space-between column>
                          <v-select :disabled="yenimi" hide-details label="Ana Şirketi Seçiniz" item-value="MusteriKod"
                            persistent-hint :items="AnaSirketler" item-text="MusteriUnvan" v-model="AnaSirket" bottom></v-select>
                        </v-layout>
                      </v-flex>
                      <v-flex pa-1 xs6 sm6 md6>
                        <v-layout justify-space-between column>
                          <v-radio-group hide-details v-model="kullanicitipi" label="Kullanıcı Tipi" column>
                            <v-radio label="Standart" :value="0"></v-radio>
                            <v-radio label="Admin" :value="1"></v-radio>
                          </v-radio-group>
                        </v-layout>
                      </v-flex>
                      <v-flex pa-1 xs6 sm6 md6>
                        <v-layout justify-space-between column>
                          <v-checkbox hide-details v-model="aktifmi" label="Aktif"></v-checkbox>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-layout>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="info" flat @click="sirketduzenleiptal()">Vazgeç</v-btn>
            <v-btn color="info" flat v-if="dialogguncellebtn" @click="satirguncelle()">Satırı Güncelle</v-btn>
            <v-btn color="info" v-if="dialogeklebtn" flat @click="listeyeekle()">Ekle</v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-toolbar color="info" dark app :clipped-left="$vuetify.breakpoint.mdAndUp" fixed>
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>

        <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
          <span class="hidden-sm-and-down">Kullanıcı İşlemleri</span>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn @click="kullaniciguncelle()" flat> <span class="hidden-sm-and-down"> Güncelle </span>
        </v-btn>
        <v-menu offset-y>
          <v-btn slot="activator" dark icon>
            <v-icon>more_vert</v-icon>
          </v-btn>

          <v-list>
            <a target="_self" v-bind:href="'#/uye/index/'">
              <v-list-tile>
                <v-list-tile-title>İptal</v-list-tile-title>
              </v-list-tile>
            </a>
          </v-list>
        </v-menu>


      </v-toolbar>


      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
        :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
      </v-snackbar>

    </v-app>
  </div>

</template>

<script>
  import auth from '../../../../api/auth'
  import _ from 'underscore'
  import router from '../../../../router'
  import helpers from "@/components/app/customcomp/helpers.js"
  import navi from "@/components/app/account/navigator.vue"

  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import bolumcomp from "@/components/app/bilet/partpage/bolumcomp.vue"
  import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"

  export default {
    data: () => ({
      yenimi: true,
      sirketitems: [],
      detay: false,
      listeleme: true,
      active: null,
      UserInfo: {
        AdSoyad: null,
        Deleted: null,
        Email: null,
        GSM: null,
        KullaniciAdi: null,
        Sifre: null,
        UserID: null
      },
      yetkilist: [],
      listegorunum: true,
      islem: false,
      dialoglisteduzenle: false,
      kullanicitipi: 0,
      aktifmi: false,
      dialogbaslik: null,
      dialogeklebtn: false,
      dialogguncellebtn: false,

      ManageInfo: {
        UserInfo: {
          UserID: null,
          AdSoyad: null,
          KullaniciAdi: null,
          Email: null,
          GSM: null,
          Sifre: null,
          Deleted: false,
        },
        AnaSirketInfo: []
      },

      WebUserAnaSirket: {
        MusteriID: null,
        MusteriKod: null,
        MusteriUnvan: null,
        UserTip: 0,
        Aktif: false
        // Masraf: null,
        // Referans: null,
        // Bolum: null,
      },

      WebUserAnaSirket1: {
        MusteriID: null,
        MusteriKod: null,
        MusteriUnvan: null,
        UserTip: 0,
        Aktif: false
        // Masraf: null,
        // Referans: null,
        // Bolum: null,
      },

      kaydetbtn: false,
      guncellebtn: false,
      eklebtn: true,
      itemseklenen: [],
      degistirilensirket: null,



      yedekresponse: [],
      bekle: false,
      AnaSirketlerWiev: [],
      AnaSirketler: [],
      Sirketler: [],
      AnaSirket: {},
      Sirket: {},
      giris: true,
      Urunler: false,
      urunlerlist: [],
      active: false,
      sektor: '0',
      uyeliktipi: '0',
      productshow: [],
      odemetipi: false,
      havale: true,
      kredikarti: false,
      odemeekrani: false,
      toplamtutar: 0,
      urunekrani: true,
      musteriid: null,
      dialogyenisirket: false,
      yenisirketunvani: null,
      sirkettipi: '0',
      karttipi: [{
          id: 'M',
          text: 'Master Card'
        },
        {
          id: 'VI',
          text: 'VISA'
        },
        {
          id: 'A',
          text: 'American Express'
        },
      ],
      sonkullanimAy: [{
          id: '01',
          text: '1'
        },
        {
          id: '02',
          text: '2'
        },
        {
          id: '03',
          text: '3'
        },
        {
          id: '04',
          text: '4'
        },
        {
          id: '05',
          text: '5'
        },
        {
          id: '06',
          text: '6'
        },
        {
          id: '07',
          text: '7'
        },
        {
          id: '08',
          text: '8'
        },
        {
          id: '09',
          text: '9'
        },
        {
          id: '10',
          text: '10'
        },
        {
          id: '11',
          text: '11'
        },
        {
          id: '12',
          text: '12'
        }
      ],
      sonkullanimYil: [
        '2005', '2006', '2007', '2008', '2009', '2010', '2011', '2012', '2013', '2014', '2015',
        '2016', '2017',
        '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028',
        '2029', '2030'
      ],
      dictionary: {
        custom: {
          kartno: {
            required: () => 'Bu alan boş bırakılamaz',
            min: 'Kart numarası 16 haneli olmalıdır.'
          },

          selectkarttipi: {
            required: () => 'lütfen seçiminizi yapınız',
          },
          kartcari: {
            required: () => 'lütfen seçiminizi yapınız',
          },
          selectsonkullanim: {
            required: () => 'lütfen seçiminizi yapınız',
          },
          selectsonkullanimyil: {
            required: () => 'lütfen seçiminizi yapınız',
          },

        }
      },

      itemsnavi: [{
          icon: 'business',
          text: 'Şirket İşlemleri',
          to: 'anasirket',
        },
        {
          icon: 'people',
          text: 'Üye İşlemeleri',
          to: 'login-uye'
        },

      ],
      clipped: true,
      drawer: true,
      fixed: false,
      miniVariant: false,
      right: true,
      rightDrawer: false,
      UrunKayit: {
        ID: null,
        MusteriInfo: {
          MusteriID: null,
          MusteriKod: null
        },
        UrunInfo: {
          UrunID: null
        },
        UrunAdet: 1,
        BaslangicTarih: null,
        BitisTarih: null,
        Kontor: null,
        KalanKontor: null,
        SatisTarihi: null,
        SatisTutar: 0,
        Aktif: null,
        OdemeOnay: 'false'
      },

      mevcutsirketmi: true,
      yenisirket: false,
      dialog: false,
      items: [{
          icon: 'domain',
          text: 'Şirket İşlemleri'
        },
        {
          icon: 'contacts',
          text: 'Üye İşlemleri'
        },
      ],

      faturainfo: [],
      newuserstatus: false,
      loginstatus: true,
      drawer: null,
      e1: 0,
      e2: true,
      e3: true,
      e4: true,
      text1: '',
      snackbar: false,
      y: 'top',
      x: 'right',
      mode: '',
      timeout: 6000,
      rules: {
        required: (value) => !!value || 'Gerekli alan.',
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Hatalı e-mail.'
        }
      },
      YeniKullanici: {
        UserID: null,
        MusteriID: 0,
        KullaniciAdi: null,
        Email: null,
        Sifre: null,
        Tip: 0,
        AdSoyad: null,
        Deleted: false,
        Aktif: false,
        MusteriBilgi: [],
        OdemeOnay: false,
      },
      unvan: null,
      confirm: null,
      Credential: {
        email: '',
        password: ''
      },
      valid: true,
      errorMsg: '',
      errorAlert: false,
      AnaSirketler: [],
      Sirketler: [],
      AnaSirket: {},
      Sirket: {}
    }),
    props: {
      source: String
    },
    methods: {
      logout() {
        auth.logout()
      },
      satirekle() {
        var response2 = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));
        this.AnaSirketler = helpers.yetkilisirketlerigetir(response2.AnaSirketInfo)

        this.yenimi = false;
        this.dialogbaslik = 'Yeni Satır Ekle'
        this.dialogeklebtn = true
        this.dialogguncellebtn = false
        this.dialoglisteduzenle = true;
      },

      satirguncelle() {

        //satırı yedekle

        var yedeklist = this.yetkilist
        var silinenkayit = null

        // değiştirilecek kayıtı sil ve yedekle

        for (var i = 0; i < this.yetkilist.length; i++) {
          if (this.yetkilist[i].MusteriKod == this.degistirilensirket) {
            silinenkayit = this.yetkilist[i]
            this.yetkilist.splice(i, 1);
          }
        }


        // yeni eklenmek istenen şirketten varmı

        var kayitvarmi = this.yetkilist.map(function (e) {
          return e.MusteriKod;
        }).indexOf(this.AnaSirket);

        if (this.AnaSirket != null && typeof (this.AnaSirket) != 'object') {
          if (kayitvarmi === -1) {
            var yenikayit = {
              MusteriID: this.WebUserAnaSirket1.MusteriID,
              MusteriKod: this.WebUserAnaSirket1.MusteriKod,
              MusteriUnvan: this.WebUserAnaSirket1.MusteriUnvan,
              UserTip: this.kullanicitipi,
              Aktif: this.aktifmi
            }
            this.yetkilist.push(yenikayit)
            this.dialoglisteduzenle = false
          } else {
            this.text1 = "Yetki Vermek İstediğiniz Şirket Listede Mevcuttur."
            this.snackbar = true
            this.yetkilist.push(silinenkayit)
          }
        } else {
          this.text1 = "Ana Şirketi Seçiniz"
          this.snackbar = true
        }


      },
      yenikullanicikaydet() {
        if (this.itemseklenen.length > 0) {

          if (this.ManageInfo.UserInfo.AdSoyad != null && this.ManageInfo.UserInfo.Email != null && this.ManageInfo.UserInfo
            .GSM != null) {
            this.ManageInfo.AnaSirketInfo = this.itemseklenen;

            var userparams = this.ManageInfo

            this.$http.post(auth.API_URL + 'api/Register/WebUserManageSave', userparams, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {

              this.text1 = response.body.ResponseMessage
              this.snackbar = true

            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable-WebUserManageSave'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable-WebUserManageSave'
                this.snackbar = true
              }
            })

          } else {
            this.text1 = "Lütfen Kullanıcı Bilgilerini Ekleyiniz"
            this.snackbar = true
          }


        } else {
          this.text1 = "Lütfen şirket ekleyiniz"
          this.snackbar = true
        }


      },
      listesil(val) {

        for (var i = 0; i < this.yetkilist.length; i++) {
          if (this.yetkilist[i].MusteriKod == val.MusteriKod) {
            this.yetkilist.splice(i, 1);
          }
        }
      },
      listeyeekle() {


        var kayitvarmi = this.yetkilist.map(function (e) {
          return e.MusteriKod;
        }).indexOf(this.AnaSirket);



        if (this.AnaSirket != null && typeof (this.AnaSirket) != 'object') {
          if (kayitvarmi === -1) {
            var yenikayit = {
              MusteriID: this.WebUserAnaSirket1.MusteriID,
              MusteriKod: this.WebUserAnaSirket1.MusteriKod,
              MusteriUnvan: this.WebUserAnaSirket1.MusteriUnvan,
              UserTip: this.kullanicitipi,
              Aktif: this.aktifmi,

            }
            this.yetkilist.push(yenikayit)
            this.dialoglisteduzenle = false
          } else {
            this.text1 = "Kayıt listede bulunmaktadır."
            this.snackbar = true
          }
        } else {
          this.text1 = "Ana Şirketi Seçiniz"
          this.snackbar = true
        }
      },
      detayagit(val1) {
        var response2 = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));

        this.AnaSirketler = helpers.yetkilisirketlerigetir(response2.AnaSirketInfo)

        console.log(this.AnaSirketler)

        this.yenimi = true;


        var kod = val1.MusteriKod

        this.kullanicitipi = val1.UserTip
        this.aktifmi = val1.Aktif
        this.degistirilensirket = val1.MusteriKod
        this.dialoglisteduzenle = true;
        this.dialogbaslik = 'Satır Güncelle'
        this.AnaSirket = String(kod)
        this.dialogeklebtn = false
        this.dialogguncellebtn = true

      },
      yenikullaniciekle() {

        var response = JSON.parse(window.localStorage.getItem('response'));
        this.AnaSirketler = response.MusteriDbler
        this.listegorunum = false,
          this.islem = true;
        this.kaydetbtn = true;
        this.guncellebtn = false;
        this.eklebtn = false;
      },

      sirketduzenleiptal() {
        this.dialoglisteduzenle = false
      },
      kullaniciguncelle
    },
    beforeMount: beforeMount,
    components: {
      navi,
      referansmerkezicomp,
      masrafmerkezicomp,
      bolumcomp
    },

    watch: {
      'AnaSirket': function (value) {
        if (value != null) {
          this.AnaSirketler.forEach(element => {
            if (element.MusteriKod == value) {
              this.WebUserAnaSirket1.MusteriKod = element.MusteriKod
              this.WebUserAnaSirket1.MusteriUnvan = element.Ad
              this.WebUserAnaSirket1.MusteriID = element.MusteriID
            }
          });
        }
      },

    },
    filters: {

    },
  }

  function beforeMount() {

    var response2 = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));



    var userparams = {
      Email: this.$route.params.id,
    }

    this.$http.post(auth.API_URL + 'api/Register/WebUserManageLoad', userparams, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.ManageInfo = response.body

      var yetkibilgisieklenmislist = []

      console.log('ana yetki' + response2.AnaSirketInfo)


      response.body.AnaSirketInfo.forEach(element => {
        //ana giriş yapan yetkilerine bak

        var kayitvarmi = response2.AnaSirketInfo.map(function (e) {
          return e.MusteriKod;
        }).indexOf(element.MusteriKod);


        var kayit = {
          Aktif: element.Aktif,
          Bolum: element.Bolum,
          Masraf: element.Masraf,
          MusteriID: element.MusteriID,
          MusteriKod: element.MusteriKod,
          MusteriUnvan: element.MusteriUnvan,
          Referans: element.Referans,
          UserTip: element.UserTip,
          Yetki: response2.AnaSirketInfo[kayitvarmi].UserTip
        }

        yetkibilgisieklenmislist.push(kayit);

      });

      this.yetkilist = yetkibilgisieklenmislist

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-WebUserManageLoad'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-WebUserManageLoad'
        this.snackbar = true
      }
    })


  }


  function kullaniciguncelle() {


    this.ManageInfo.AnaSirketInfo = this.yetkilist

    var userparams = this.ManageInfo

    this.$http.post(auth.API_URL + 'api/Register/WebUserManageUpdate', userparams, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.text1 = response.body.ResponseMessage
      this.snackbar = true

      if (response.body.Status == true) {

        var url = '#/uye/index'
        setTimeout(function () {
          window.open(url, '_self')
        }.bind(this), 5000)

      }


    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-WebUserManageUpdate'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-WebUserManageUpdate'
        this.snackbar = true
      }
    })

  }
</script>